import legal1 from "../../assets/legal/legal1.png";
import legal2 from "../../assets/legal/legal2.png";
import legal3 from "../../assets/legal/legal3.png";
import legal4 from "../../assets/legal/legal4.png";
const Termsofservice = () => {
  return (
    <div className="help_content_page" style={{ height: "max-content" }}>
      <div className="nav_main_header border-b d-md-block d-none">
        <p style={{ fontWeight: 400, fontSize: 30 }}>
          {" "}
          <img src={legal1} alt={"terms and condition"}></img> Terms of Service{" "}
        </p>
      </div>
      <div className="trade_content nav_section border-b">
        {/* <div className="section_header d-flex">
                    <h1><img src={tradeIcon} alt="trade icon" />Trade</h1>
                </div> */}
        <p style={{ lineHeight: 2 }}>
          <strong>
            These Terms of Service were last updated on the 2nd of January 2023
          </strong>
        </p>
        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          indexx.ai does not provide fiat/crypto exchange service. An exchange
          service is provided only on the third party&rsquo;s platform by a
          third provider. By visiting, accessing, or using
          https://indexx.ai&rsquo;s/ as well as associated application program
          interface or mobile applications and technology platform integrated
          therein (&ldquo;Services&rdquo;), You (&ldquo;User&rdquo; or
          &ldquo;You&rdquo;) consent to the Terms of Service (the
          &ldquo;Terms&rdquo;) hereby stated. indexx.ai (The correspondent
          address of the Company shall be at the offices of &#1089;/&#1086;
          Irvine Technology Center ,Irvine, CA 92618,California), is the
          operator of the technology platform as well as the website, and
          associated application program interface and mobile applications.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          The Terms of Service constitute the agreement and understanding
          regarding the use of any or all of the Services, and any manner of
          accessing them, between You and indexx.ai (&ldquo;Service
          Provider&rdquo;).
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          By clicking on the &quot;Exchange&quot; button or by visiting the
          Site, we may provide You with access and utility through our trading
          platform via software, API (application program interface),
          technologies, products and/or functionalities. The services that We
          offer through the Site (the &ldquo;Services&rdquo;) are: <br />
          <br />
          <ul>
            <li>
              {" "}
              1. an exchange of the crypto asset of one type, owned by one User,
              to the crypto asset of another type, owned by the same or another
              User, at the terms and conditions set forth by such exchange
              parties, and which is executed solely and exclusively within the
              Services with crypto assets deposited to those Users&rsquo;
              accounts. In no case shall the Services be deemed or construed to
              be a marginal trade;{" "}
            </li>

            <li>
              {" "}
              2. Service Provider undertakes deposit, withdrawal and/or trade
              transaction of crypto asset into, out from or at Customer Account
              , which is technically executed by Service Provider in accordance
              with User&rsquo;s instructions. Service Provider does not provide
              You with financing services and thus, does not perform and support
              margin trading. The trade on the integrated platform takes place
              between Users. As described in the Terms, You agree to be legally
              bound by these Terms of Service, as well as indexx.ai&rsquo;s
              Affiliate Program Terms of Service and indexx.ai&rsquo;s KYC
              Terms, which constitute inseparable part of these Terms. If You do
              not agree to be bound by these terms, do not access or use the
              Services.
            </li>
          </ul>
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          As described in the Terms, You agree to be legally bound by these
          Terms of Service and all terms incorporated by reference. If You do
          not agree to be bound by these terms, do not access or use the
          Services. We reserve the right to change or modify the terms and
          conditions contained in the Terms of Service, including but not
          limited to any policy or guideline of the platform, at any time and at
          our sole discretion. We will provide notice of these changes by
          posting the revised Terms of Service and changing the &quot;Last
          updated&quot; date at the top of the Terms of Service, or by emailing
          Users at their provided email addresses, or by any other means as
          determined by us at our sole discretion. Any changes or modifications
          will be effective immediately upon posting the revisions to the
          website or at the instant that we transmit the information. These
          changes will apply at that instant to all then current and subsequent
          uses or Services.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          You waive any right You may have to receive specific notice of such
          changes or modifications. Your continued use of this platform acts as
          acceptance of such changes or modifications. If You do not agree to
          the Terms in effect when You access or use the platform, You must stop
          using our Services. We encourage You to frequently review the Terms to
          ensure that You understand the terms and conditions that apply to your
          access to, and use of, the Services.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          The Terms of Service and any terms expressly incorporated herein apply
          to your access to, and use of, any services provided by Service
          Provider. The Terms of Service do not alter in any way the terms or
          conditions of any other agreement You may have with the Service
          Provider for products, services or otherwise. If You are using the
          Service on behalf of any entity, You represent and warrant that (a)
          such legal entity is duly organized and validly existing under the
          applicable laws of the jurisdiction of its organization and (b) You
          are authorized to accept the Terms on such entity&rsquo;s behalf and
          that such entity agrees to be responsible to us if You violate the
          Terms.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          You should read the Terms of Service, and any document referred to in
          them very carefully. If there is anything that You do not understand
          in the Terms and any document referred to herein, you should discuss
          this matter with us and seek the necessary clarification. Any formal
          communication with You will be undertaken through electronic mail
          unless otherwise instructed. Documents will be sent to you by
          electronic mail and you should seek to send any documents to us by the
          same means. You will also be able to contact us telephonically. Any
          formal communication with You will, unless otherwise agreed, be made
          in the English language. In the event of any discrepancy between the
          English language version of the Terms of Service or any such
          communications and any translation of the Terms of Service or such
          communications (as applicable) in a foreign language, the respective
          English version shall prevail
        </p>

        <p style={{ lineHeight: 2, fontSize: 20, fontWeight: "bold" }}>
          <br />
          <br />
          <img src={legal2} alt="description of services"></img> DESCRIPTION OF
          SERVICES
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          While we have made every effort to ensure the accuracy of the
          information on our website, the information and content on the website
          is subject to change without notice and is provided for the sole
          purpose of assisting Users to make independent decisions. We have
          taken reasonable measures to ensure the accuracy of the information on
          the website; however, we do not guarantee the accuracy, suitability,
          reliability, completeness, performance and/or fitness for purpose of
          the content of any Services or products available through the website,
          and will not accept liability for any loss or damage that may arise
          directly or indirectly from the content or your inability to access
          the Site, for any delay in or failure of the transmission or the
          receipt of any instruction or notifications sent through our platform.
          We will not have any liability for the use or interpretation of such
          information.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Users shall prepare devices and bear costs as follows: 1)
          internet-connected device, including but not limited to computer or
          other internet-connected terminals; 2) internet-accessing costs,
          including but not limited to internet fees, rental charges for
          internet-connected equipment, cellular data fees, etc.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          While using the Services, You accept the information services provided
          by us. You hereby authorize us to send commercial information to You
          via e-mail, SMS, mobile notification, or mailing address. You can opt
          out of such services by changing relevant settings on the website. You
          acknowledge and consent that the Services are provided by us according
          to its current technological capacity and other conditions. While we
          have made every effort to ensure continuity and security of the
          Services, we are unable to completely foresee and hedge legal,
          technological and other risks including but not limited to force
          majeure, virus, hacker attack, system instability, flaw in third-party
          services, act of government, etc. that may result in service
          interruption, data loss and other losses and risks.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          When the system platform is unable to operate properly because of the
          following circumstances and the User is unable to access the Services
          or place or cancel an order, we assume no liability for damages. These
          circumstances include, but are not limited to:
          <br />
          1.System downtime during maintenance; <br />
          2.Telecom or Networking equipment issues; Typhoon, earthquake,
          tsunami, flood, power failure, war, terrorist attacks, and other force
          majeure factors; <br />
          3.Any other issues, including hacker attacks, computer virus intrusion
          or attack, website or backend maintenance and upgrade, banking related
          issues, government regulation or mandates, and any other third party
          issues;
          <br />
          Damages to Users or other third parties caused by third parties.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          For abnormal transactions, market interruption and other abnormal
          conditions caused by system failure, network failure, distributed
          denial of service attacks (DDos) and other hacker attacks and other
          unexpected factors, we have the right to cancel the abnormal
          transaction results. We have the right to rollback all the
          transactions of a certain period of time.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          We shall not ask for any password from our Users, nor shall we ask
          Users to transmit any funds, addresses, as applicable, that are not
          listed on the trading platform. We shall not be responsible for any
          losses caused by transmitting funds, addresses, as applicable, that
          are not listed on the trading platform.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Abnormal transaction handling: While using the Services, You agree and
          acknowledge the possibility of discontinuity and disruption of the
          Services due to connectivity problems of the networks or other force
          majeure. Users shall make sure to provide only correct information.
          Service Provider does not assume any responsibility of any losses
          caused by the aforementioned situations due to your providing
          incorrect information that results our inability reaching out and
          explaining to You the handling procedures. We have the right to know
          the purpose and background of the Users who use our products or
          services. Users should provide comprehensive and accurate information
          as required. If we have reasonable grounds to suspect that the User
          has provided false trading information, we are entitled to restrict
          the User from the use of some or all of our products and services
          temporarily or permanently.
        </p>

        <p style={{ lineHeight: 2, fontSize: 20, fontWeight: "bold" }}>
          <br />
          <br />
          <img src={legal3} alt="risk disclosure"></img> RISK DISCLOSURE
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Trading of crypto assets involves significant risk. The risk of loss
          in trading or holding crypto assets can be substantial. You should
          therefore carefully consider whether using the Services is suitable
          for You in light of your financial condition. There is no assurance
          that our trading market will be orderly and stable. You should
          exercise prudence in trading in crypto assets (as well as any other
          assets). Prices can and do fluctuate at any given moment for any
          reason. Due to such price fluctuations, You may gain or lose value in
          your assets at any given moment. Any trading position may be subject
          to large swings in value and may even become worthless. The User shall
          bear any loss resulted in his/her own fault or error, including but
          not limited to: not in accordance with the transaction prompts
          operation, not timely trading operations, forgetting or leakage of
          passwords, passwords are cracked, and/or the Users computer is invaded
          or hacked by others.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          In the event of a potential loophole in the trading rules that
          unjustly enriches the User, we will contact the User to recover the
          gains. The User must effectively cooperate, otherwise, we will take
          actions, including, but not limited to restrictions on account
          transactions, freezing account funds, prosecution of the User in a
          court with right of jurisdiction and other recourse measures. In the
          event that the User does not cooperate, the User will also bear
          recourse costs. Please note that: You may sustain a total loss of the
          crypto assets in your User Address, and, in some cases, you may incur
          losses beyond such crypto assets. Under certain market conditions, you
          may find it difficult or impossible to liquidate a position. This can
          occur, for example, when the market reaches a daily price fluctuation
          limit (&quot;limit move&quot;) and there is insufficient liquidity in
          the market. Placing instructions in order to recover the transaction,
          will not necessarily limit your losses to the intended amounts, since
          market conditions may make it impossible to execute such instructions.
          All crypto assets positions involve risk, and a &quot;spread&quot;
          position may not be less risky than an outright &quot;long&quot; or
          &quot;short&quot; position. All of the points noted above apply to all
          crypto assets. This brief statement cannot, however, disclose all the
          risks and other aspects associated with the Trade of crypto assets and
          shall not be considered as any professional advice.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          YOU AGREE TO INDEMNIFY AND HOLD SERVICE PROVIDER HARMLESS AGAINST ANY
          CLAIMS, DEMANDS AND DAMAGES, WHETHER DIRECT, INDIRECT, CONSEQUENTIAL
          OR SPECIAL, OR ANY OTHER DAMAGES OF ANY KIND, INCLUDING, BUT NOT
          LIMITED TO, LOSS OF USE, LOSS OF PROFITS OR LOSS OF DATA, WHETHER IN
          AN ACTION, IN CONTRACT, TORT (INCLUDING BUT NOT LIMITED TO NEGLIGENCE)
          OR OTHERWISE, ORIGINATED FROM OR IN ANY WAY CONNECTED WITH YOUR USE OF
          OUR TECHNOLOGY PLATFORM, INCLUDING, BUT NOT LIMITED TO THOSE ARISING
          FROM YOUR PERSONAL ERROR AND MISBEHAVIOR SUCH AS FORGOTTEN PASSWORDS,
          INCORRECTLY CONSTRUCTED TRANSACTIONS, LOSS OF YOUR ACCESSES ETC.
          ELIGIBILITY AND PROHIBITION OF USING THE SERVICES
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          The Services are intended solely for Users who are 18 or older. By
          accessing or using our Services, You represent and warrant that You
          are at least 18 years old and have not previously been suspended or
          removed from the Services; have full power and authority to enter into
          this legal relationship and by doing so will not violate any other
          legal relationships; guarantee that your crypto assets, which you
          transfer to the Services are not sold, encumbered, not in contention,
          or under seizure, and that neither exist any rights of third parties
          to your crypto assets; use our Services with your own e-mail and for
          your own benefit and do not act on behalf and/or to the interest of
          any other person; are not Politically Exposed Person (PEP) or family
          member or close associate of the PEP. PEPs (as well as family members
          or close associates of the PEPs) are not allowed to use the Services.
          You also represent and warrant that You are not on any trade or
          economic sanctions lists, such as the United Nations Security Council
          Sanctions List, nor restricted or prohibited from engaging in any type
          of trading by administrative law enforcement agencies.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Also, we may not make all of the Services available in all markets and
          jurisdictions, and may restrict or prohibit use of all or a portion of
          the Services from Restricted Locations, which at this time include the
          USA, France, North Korea, Sudan, Crimea and Sevastopol, Republic of
          Cuba, Syrian Arab Republic, People&rsquo;s Republic of China, Japan,
          Republic of Iraq, Republic of Yemen, Federal Republic of Somalia,
          Republic of Congo, State of Libya, Republic of Liberia, State of
          Eritrea, Republic of Mali, Republic of Zimbabwe, Republic of
          C&ocirc;te d&rsquo;Ivoire, the Islamic Republic of Iran and any state,
          country or other jurisdiction that is embargoed by England and Wales,
          a jurisdiction where the local laws prohibit you at any time (by
          reason of your nationality, domicile, citizenship, residence or
          otherwise) to access or use the Services. The content of the Terms
          shall not be excluded from the laws of the country or region under
          which the User belongs. As a result, if You do not meet these
          eligibility requirements, do not use our Services.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Service Provider reserves the right to close any of your User Address,
          to reject any User&rsquo;s exchange instructions, and to force you to
          withdraw all the crypto assets from the Services in case if: (i)
          Service Provider determines that you are accessing the Services from
          any of the restricted jurisdictions listed above, or (ii) you have
          given false representations as to your location of incorporation,
          establishment, citizenship or place of residence.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          When accessing or using the Services, you further represent, agree and
          warrant, that you will not violate any law, contract, intellectual
          property or other third-party right or commit a tort, and that you are
          solely responsible for your conduct while using our the Services.
          Without prejudice to the generality of the foregoing, you represent,
          agree and warrant, that you will not: Customers shall not apply
          circumvention or obfuscating technologies to disguise their IP
          addresses or to hide the details of the transaction; Customers shall
          not create or distribute any technologies which infringe or which
          would assist other customers to infringe the terms hereof including
          for disguising IP addresses or to obfuscate details of the
          transaction; Use the Services in any manner that could interfere with,
          disrupt, negatively affect or inhibit other users from using the
          Services with full functionality, or that could damage, disable,
          overburden or impair the functioning of the Services in any manner;
          Use the Services to pay for, support or otherwise engage in any
          illegal gambling activities; fraud; money-laundering; or terrorist
          activities; or any other illegal activities; Use any robot, spider,
          crawler, scraper or other automated means or interface not provided by
          Us to access the Services or to extract data; Use or attempt to use
          another User Address without authorization; Attempt to circumvent any
          content filtering techniques We employ, or attempt to access any
          service or area of our Services that you are not authorized to access;
          Develop any third-party applications that interact with our Services
          without our prior written consent; Provide false, inaccurate, or
          misleading information; Encourage or induce any third party to engage
          in any of the activities prohibited under this Section.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          YOU INDEMNIFY AND HOLD SERVICE PROVIDER HARMLESS AGAINST ANY CLAIMS,
          DEMANDS AND DAMAGES, WHETHER DIRECT, INDIRECT, CONSEQUENTIAL OR
          SPECIAL, OR ANY OTHER DAMAGES OF ANY KIND, INCLUDING, BUT NOT LIMITED
          TO, LOSS OF USE, LOSS OF PROFITS OR LOSS OF DATA, WHETHER IN AN ACTION
          IN CONTRACT, TORT (INCLUDING BUT NOT LIMITED TO NEGLIGENCE) OR
          OTHERWISE, ORIGINATED FROM OR IN ANY WAY CONNECTED WITH INVALIDITY OR
          BREACH OF ANY OF THE WARRANTIES, REPRESENTATIONS AND COVENANTS OF THIS
          SECTION AND THE ENTIRE TERMS.
        </p>

        <p
          style={{
            fontWeight: 400,
            fontSize: 30,
            paddingTop: 20,
            marginBottom: -30,
          }}
        >
          {" "}
          <img src={legal4} alt={"user address"}></img> USER ADDRESS
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          In order to use the full functionality of the Services a User Address
          shall be created. The Service Provider is entitled to assign the User
          Address to each User in a form the Service Provider things fit
          depending on the complexity of the Services provided upon its own
          discretion, including, but not limited to different combinations of
          characters (e.g. e-mail, special ID, etc.)
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          You are not entitled to assign and/or use your User Address to any
          third party, neither You can transfer your User Address details to any
          third party.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          When creating your User Address you undertake to: - take full
          responsibility for all activities that occur under your User Address;
          - provide accurate and truthful information; - agree to pass through
          AML/KYC procedures which may be applied to You from time to time; -
          maintain and promptly update your User information; - promptly notify
          Service Provider if you discover or otherwise suspect any security
          breaches related to your User Address.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          In case of your breach of the Terms, or any other event as We may deem
          necessary, including without limitation market disruption and/or Force
          Majeure event We may, in our sole discretion and without liability to
          you, with or without prior notice: suspend your access to all or a
          portion of our Services; or prevent you from completing any actions
          via the Services, including closing any open trade orders. In case the
          transferring resumes, you acknowledge that prevailing market rates may
          differ significantly from the rates available prior to such event; or
          terminate your access to the Services, delete or deactivate your User
          Address and all related information and files in such account. In the
          event of termination, Service Provider will return any crypto assets
          stored in your User Address and not owed to Service Provider, unless
          Service Provider believes you have committed fraud, negligence or
          other misconduct.
        </p>

        <p
          style={{
            fontWeight: 400,
            fontSize: 30,
            paddingTop: 20,
            marginBottom: -30,
          }}
        >
          {" "}
          <img
            src={legal4}
            alt={"deposit/withdrawal of crypto asset"}
          ></img>{" "}
          DEPOSIT/WITHDRAWAL OF CRYPTO ASSETS TO USER ADDRESS
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Services allow Users to remit crypto assets to their User Address from
          external third-party service and vice versa except to certain
          limitations, which may be updated from time to time. YOU INDEMNIFY AND
          HOLD SERVICE PROVIDER HARMLESS AGAINST ANY CLAIMS, DEMANDS AND
          DAMAGES, WHETHER DIRECT, INDIRECT, CONSEQUENTIAL OR SPECIAL, OR ANY
          OTHER DAMAGES OF ANY KIND, INCLUDING, BUT NOT LIMITED TO, LOSS OF USE,
          LOSS OF PROFITS OR LOSS OF DATA, WHETHER IN CONTRACT, TORT (INCLUDING
          BUT NOT LIMITED TO NEGLIGENCE) OR OTHERWISE, ORIGINATED FROM OR IN ANY
          WAY CONNECTED WITH YOUR DEPOSIT/WITHDRAWAL TRANSFER REQUESTED IN
          VIOLATION OF SETTLED LIMITATIONS. You may be charged fees by the
          third-party service you use to remit your User Address. Service
          Provider is not responsible for any third-party services' fees. You
          are solely responsible for your use of the third-party service, and
          you agree to comply with all terms and conditions applicable to any
          third-party service.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          In some cases, the third-party service may reject your crypto assets
          to be processed, suspend the deposit/withdrawal transfer of your
          crypto assets, or be not able to support the transfer, or may
          otherwise be unavailable. YOU AGREE THAT YOU WILL NOT HOLD SERVICE
          PROVIDER LIABLE FOR ANY CLAIMS, DEMANDS AND DAMAGES, WHETHER DIRECT,
          INDIRECT, CONSEQUENTIAL OR SPECIAL, OR ANY OTHER DAMAGES OF ANY KIND,
          INCLUDING, BUT NOT LIMITED TO, LOSS OF USE, LOSS OF PROFITS OR LOSS OF
          DATA, WHETHER IN AN ACTION IN CONTRACT, TORT (INCLUDING BUT NOT
          LIMITED TO NEGLIGENCE) OR OTHERWISE, ORIGINATED FROM OR IN ANY WAY
          CONNECTED WITH SUCH REJECTED OR SUSPENDED ETC. DEPOSIT/WITHDRAWAL
          TRANSFERS.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          You understand and acknowledge, that an address for receiving crypto
          asset will be created automatically as soon as you request the deposit
          transfer and before any crypto asset can be remitted to Your User
          Address and you fully and irrevocably authorize its creation.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          In case you are required to verify, that you possess crypto asset of
          the third-party service that you use to remit crypto asset to your
          User Address, you undertake to provide such verification by following
          Service Provider instructions.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          When you request Us to deposit/withdraw crypto assets into or out from
          your User Address, you authorize Service Provider to execute such
          transfer via the Service Provider&rsquo; Services.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Subject to the terms and conditions of these Terms, We will use
          commercially reasonable efforts to record all transfers on a spot
          basis as soon as practicable. However, the timing associated with
          deposit/withdrawal of crypto assets depends inter alia upon the
          performance of third-parties services, and We make no guarantee that
          crypto assets will be deposited/withdrawn in any specific timeframe.
          YOU HEREBY UNDERSTAND AND ACKNOWLEDGE, THAT ANY DELAYS ARE POSSIBLE;
          YOU INDEMNIFY AND HOLD SERVICE PROVIDER HARMLESS AGAINST ANY CLAIMS,
          DEMANDS AND DAMAGES, WHETHER DIRECT, INDIRECT, CONSEQUENTIAL OR
          SPECIAL, OR ANY OTHER DAMAGES OF ANY KIND, INCLUDING, BUT NOT LIMITED
          TO, LOSS OF USE, LOSS OF PROFITS OR LOSS OF DATA, WHETHER IN AN ACTION
          IN CONTRACT, TORT (INCLUDING BUT NOT LIMITED TO NEGLIGENCE) OR
          OTHERWISE, ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE TRANSFER
          DELAY, WHETHER ORIGINATED FROM OUR FAULT OR NOT.
        </p>

        <p
          style={{
            fontWeight: 400,
            fontSize: 30,
            paddingTop: 20,
            marginBottom: -30,
          }}
        >
          {" "}
          <img src={legal4} alt={"crypto assets trade"}></img> CRYPTO ASSETS
          TRADE
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          When you submit a new trade order via the Services, you authorize
          Service Provider to: record a transfer of Your crypto assets
          from/into/on your User Address and/or, where applicable, reserve Your
          crypto assets on your User Address in accordance with such trade
          order, and charge you any applicable fees for such record.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          In order to execute your trade order, you may be required to transfer
          funds from your User Address or external third-party service to an
          address provided to you by Service Provider. You acknowledge and agree
          that this address, provided you by Service Provider so that you could
          submit a trade order, applies only to such specific trade order and
          you undertake not to transfer funds to the same address once you have
          submitted your trade order.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          You acknowledge and agree that, respective to your trading activity,
          Service Provider does not act as your broker, intermediary, agent, or
          advisor or in any fiduciary capacity; does not act as a party of
          transferring of a particular crypto asset.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Each placed trade order creates different market exchange rates. You
          acknowledge and agree that the rates information made available via
          the Services may differ from prevailing rates made available via other
          sources outside of the Services.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Particularly during periods of high volume, illiquidity, fast movement
          or volatility in the marketplace for any crypto assets, the actual
          market rate at which a market trade transaction is executed may be
          different from the prevailing rate indicated via the Services at the
          time of your transaction. You understand, that We are not liable for
          any such rates fluctuations.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          The rates made available via the Services shall not be considered as
          an investment or financial pieces of advice or referred to as such and
          cannot be used as a basis of investment strategy, legal position in
          the court and nothing in the rates information can be ensured to
          contain no errors, mistakes, mispresentations or failures etc.
          THEREFORE, NEITHER SERVICE PROVIDER, NOR, WHERE APPLICABLE, ANY OF
          THEIR RESPECTIVE DIRECTORS, OFFICERS, EMPLOYEES, AGENTS OR OUTSOURCED
          ADVISORS MAKES ANY REPRESENTATION, WARRANTY OR GUARANTEE WHATSOEVER
          WITH RESPECT TO THE RATES INFORMATION AND, IN PARTICULAR, AS TO THE
          ACCURACY OR COMPLETENESS OF THE RATES INFORMATION. YOU AGREE TO
          INDEMNIFY AND HOLD SERVICE PROVIDER HARMLESS AGAINST ANY CLAIMS,
          DEMANDS AND DAMAGES, WHETHER DIRECT, INDIRECT, CONSEQUENTIAL OR
          SPECIAL, OR ANY OTHER DAMAGES OF ANY KIND, INCLUDING, BUT NOT LIMITED
          TO, LOSS OF USE, LOSS OF PROFITS OR LOSS OF DATA, WHETHER IN AN
          ACTION, IN CONTRACT, TORT (INCLUDING BUT NOT LIMITED TO NEGLIGENCE) OR
          OTHERWISE, ORIGINATED FROM OR IN ANY WAY CONNECTED WITH YOUR USE OF
          RATES INFORMATION AND/OR YOUR TRADING ACTIVITY VIA THE SERVICES.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Once your deposit/withdrawal request or trade order is executed, a
          confirmation will be electronically made available via the Services
          detailing the particulars of the transfer. You acknowledge and agree
          that the failure of the Services to provide such confirmation shall
          not prejudice or invalidate the terms of such transaction.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          We may, at any time and in our sole discretion, refuse to perform any
          transfer requested via the Services, impose limits on the transfer
          amount permitted via the Services or impose any other conditions or
          restrictions upon your use of the Services without prior notice.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Due to fast movement and/or volatility in the marketplace and/or other
          reasons which may be applicable from time to time, We reserve the
          right not to execute Your trade order, in the event that the actual
          market rate significantly increases or decreases in relation to the
          rate indicated by the Services in your trade order, in the event of
          market disruption or in any other event, as may be indicated by Us,
          and, in such case, We will not transfer crypto assets under your trade
          order and, upon Your separate instructions will: return the funds to
          Your Customer Account; or execute Your trade order in accordance with
          the rate newly indicated by the Services; or proceed otherwise, as
          reasonably instructed by the User.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          We may, in our sole discretion and without liability to you, with or
          without prior notice and at any time, modify or discontinue,
          temporarily or permanently, any portion of our Services.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          You may only cancel a transfer request initiated via the Services if
          such cancellation occurs before Service Provider executes the
          transfer. Once your transfer request has been executed, you may not
          change, withdraw or cancel your authorization for Service Provider to
          complete such transfer. If User&rsquo;s instruction has been partially
          filled, you may cancel the unfilled remainder unless the Service
          Provider has sent the execution request to the third parties. We
          reserve the right to refuse any cancellation request associated with a
          market rate trade order once you have submitted such order. While We
          may, at our sole discretion, reverse a trade under certain
          extraordinary conditions, a customer does not have a right to a
          reversal of a trade.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          If you have an insufficient amount of crypto assets in your User
          Address to complete a transfer, We may cancel the entire order or may
          fulfil a partial order using the amount of crypto assets currently
          available in your User Address, less any fees owed to Service Provider
          in connection with our execution of the transfers.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          If in trade order You have specified that after exchange relevant
          amounts are remitted not to your User Address, but to third-party
          service, and relevant third-party service rejects and/or for any other
          reason does not process amounts being remitted to above third-party
          service in due time, You undertake not to request relevant third-party
          service and/or not to credit above amounts to the address from which
          above amounts were remitted to relevant third-party service and
          immediately contact our Customer Service at support@indexx.ai to
          receive further instructions on remittance of above amounts. YOU
          INDEMNIFY AND HOLD SERVICE PROVIDER HARMLESS AGAINST ANY CLAIMS,
          DEMANDS AND DAMAGES, WHETHER DIRECT, INDIRECT, CONSEQUENTIAL OR
          SPECIAL, OR ANY OTHER DAMAGES OF ANY KIND, INCLUDING, BUT NOT LIMITED
          TO, LOSS OF USE, LOSS OF PROFITS OR LOSS OF DATA, WHETHER IN CONTRACT,
          TORT (INCLUDING BUT NOT LIMITED TO NEGLIGENCE) OR OTHERWISE,
          ORIGINATING FROM YOUR VIOLATION OF THIS SECTION.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          It is your responsibility to determine what, if any, taxes apply to
          the transfers you complete via the Technology Platform, and it is your
          responsibility to report and remit the correct tax to the appropriate
          tax authority. You agree that Service Provider is not responsible for
          determining whether taxes apply to your transfers or for collecting,
          reporting, withholding or remitting any taxes arising from any trades
          and transfers and does not act as your tax agent.
        </p>

        <p
          style={{
            fontWeight: 400,
            fontSize: 30,
            paddingTop: 20,
            marginBottom: -30,
          }}
        >
          {" "}
          <img
            src={legal4}
            alt={"special terms on fiat to crypto exchange services"}
          ></img>{" "}
          SPECIAL TERMS ON FIAT TO CRYPTO EXCHANGE SERVICES
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          The Service Provider may provide to Users additional services on
          technical possibility to access and use fiat to crypto exchange
          services of the third parties (&ldquo;Additional Services&rdquo;).
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          In order to use the Additional Service a User shall visit the Service
          Provider&rsquo;s website stipulated herein, input fiat/crypto pair
          exchange in the provided fields, amount which User willing to exchange
          and User&rsquo;s Address. Upon the successful input of information,
          User will be given access to the third party&rsquo;s platform where
          the actual service on fiat/crypto exchange will be performed by the
          third party. For the avoidance of doubt, User is provided an exchange
          service by the third party which technology platform User accesses.
          KYC procedures, deposit of funds and transaction status check will be
          undertaken at the third party&rsquo;s platform and will be between
          User and that third party provider. By accessing the Additional
          Service User understands and acknowledges the liability of the User to
          comply at all times with the terms and conditions of the third party
          provider, as well as such party&rsquo;s instructions, guidelines and
          requests.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          The Service Provider hereby assumes no liability towards the
          transactions undertaken by User with the access and use of any third
          party services.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          User will indemnify the Service Provider against any claims, requests
          related to the User&rsquo;s access and use of the third party&rsquo;s
          services.
        </p>

        <p
          style={{
            fontWeight: 400,
            fontSize: 30,
            paddingTop: 20,
            marginBottom: -30,
          }}
        >
          {" "}
          <img src={legal1} alt={"service fees"}></img> SERVICE FEES
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          You agree to reimburse the Service Provider Services by paying the
          Service Fee of 0.075% for other cryptocurrencies and 0.055% for indexx
          tokens of the input crypto asset amount of each successful transfer.
          The Service Provider may change the Fee structure from time to time,
          changes to the Fees are effective as of the effective date indicated
          in the posting of the revised Fee terms, and will apply to any
          transfers that take place following the effective date of such revised
          Fee structure. You hereby authorize Service Provider, or designated
          payment processor, to charge or deduct crypto assets as an applicable
          Fee from your User Address.
        </p>

        <p
          style={{
            fontWeight: 400,
            fontSize: 30,
            paddingTop: 20,
            marginBottom: -30,
          }}
        >
          {" "}
          <img src={legal1} alt={"refund policy"}></img> REFUND POLICY
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          By placing an exchange request on our Site, you agree to the terms of
          this Refund policy. The User may request a refund in the following
          cases: o If the exchange was assigned the status &quot;Your exchange
          has failed&quot;; o If the funds have been credited to the Indexx.ai
          deposit address and the exchange remains at the &quot;Awaiting your
          deposit&quot; stage. The exchange statuses &quot;Confirming the
          transaction&quot;, &quot;Exchanging&quot;, &quot;Sending&quot; and
          &quot;Finished successfully&quot; are non-refundable due to the
          absence of external factors. Service Provider reserves the right to
          review exchange refund requests in the aforementioned statuses on a
          case-by-case basis. Indexx.ai does not guarantee the refund of digital
          assets in case the User fails to comply with the instructions
          accompanying the exchange creation process or as indicated on the
          order page. This condition includes, but is not limited to the
          following circumstances: o Sending digital assets by the User other
          than those specified in the order or entered in the wrong network; o
          Sending Digital Assets by the User with an expired contract; o Sending
          deposit by User without obligatory tag (MEMO Destination Pag, Payment
          ID, etc.) if it is indicated on the order page; o Sending deposit
          amount lower than acceptable minimum limit set by Indexx.ai.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Service Provider reserves the right to review each case on an
          individual basis. In some of the aforementioned cases, our liquidity
          provider may charge an additional fee for assistance in the recovery
          of the User&rsquo;s funds. Partner's commission can be deducted from
          the deposit amount or can be charged separately. Refunds are not
          available for: o Counterfeit and imitation assets; o Assets sent in
          the test network. In order to request a refund, the User should
          contact Support through the official communication channels: live chat
          at indexx.ai or by e-mail at support@indexx.ai. We are not responsible
          if the User discloses information on the User's exchanges/transactions
          to third parties or applies for a refund through channels other than
          indicated. Users should not trust personal messages or inquiries
          submitted by individuals claiming to represent Indexx.ai. If you
          cannot confirm that this is an official request from Indexx.ai, please
          contact us directly at support@indexx.ai. Indexx.ai offers users to
          receive a refund to the original address or to the refund address
          entered during the creation of the exchange. However, in some cases
          Indexx.ai reserves the right to offer a refund to the original address
          as the only possible solution. Upon conducting refunds, the support
          service reserves the right to request additional confirmation of the
          deposit ownership by the User in the required form. Upon forwarding
          the refund to the User the payment required to cover the network
          commission may be charged from the original deposit amount. If the
          refunded asset is a token and not the main network coin, the User may
          be requested to make an additional payment in coins of the main
          network to cover the network commission. Indexx.ai shall not be liable
          for any funds sent to fake phishing sites that imitate the original
          Indexx.ai project. User should make sure that User is visiting the
          correct domain indexx.ai. The period during which Indexx.ai holds User
          funds is limited to 1 calendar year. After this period, Indexx.ai does
          not guarantee the safety of unclaimed funds.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br /> CHANGE, INTERRUPTION, TERMINATION, AND DISCONTINUANCE OF
          SERVICES
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Service Change and Interruption: We may change the Service and/or may
          also interrupt, suspend or terminate the service at any time with or
          without prior notice.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Service Discontinuance and Termination: we reserve the right, in our
          sole discretion, to discontinue or terminate the services provided to
          you without notice, temporarily or permanently, including, but not
          limited to, the following cases: If the personal information you have
          provided is not true, or inconsistent with the information at the time
          of registration and you have failed to provide reasonable proof
          (please remember, according to the laws or regulations you should
          submit true information); If you violate the relevant laws and
          regulations or this agreement; If required by any provisions of the
          laws and regulations, as well as the requirements of relevant
          government authorities; For security reasons or other necessary
          circumstances.
        </p>

        <p
          style={{
            fontWeight: 400,
            fontSize: 30,
            paddingTop: 20,
            marginBottom: -30,
          }}
        >
          {" "}
          <img src={legal4} alt={"promotion and marketing"}></img> PROMOTION AND
          MARKETING
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          You do hereby acknowledge that you shall seek a prior expressed
          approval of the Service Provider before utilizing any promotional
          materials in order to advertise and market the Services and products
          of the Service Provider. Any use of the promotional materials relating
          to the marketing of the Services without Service Provider&rsquo;s
          prior approval, as well as execution of any inappropriate way of
          marketing is forbidden and any such act will force us to initiate
          action.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          You do hereby further acknowledge that Service Provider grants you a
          non-exclusive, limited and non-transferable license to use the Service
          Provider&rsquo;s trademarks, service marks, logos, slogans and any
          other brand content on the promotional materials. The license hereby
          granted shall terminate upon termination of the agreement, as well as
          upon simple limitations imposed on you at Service Provider&rsquo;s
          sole discretion due to violation of the terms or our belief of
          violation. The Service Provider shall retain ownership of approved
          promotional materials. You shall immediately delete, remove, withdraw
          any promotional materials at your possession upon termination of the
          agreement.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          You are not allowed to perform the following ways of advertising,
          marketing and promotion, which the Service Provider categorizes as
          inappropriate ways of the same. Please note that the final decision on
          categorizing a particular way as inappropriate way stays by the
          Services Provider. We may terminate your affiliate account, limit your
          use of the Services, suspend any payments due, as well as your balance
          at our own discretion in case we believe you violate any of the terms
          hereby stated. You shall not: Use any illegal and/or spam method of
          advertising, such as: unsolicited email, unauthorized placing of the
          link in forums, newsgroups, message boards, etc.; Bid on keywords and
          phrases containing the Service Provider trademark, or variations or
          misspellings of the trademarked term on pay per click or pay per
          impression campaigns on the search engines without our prior approval;
          Use the Service Provider website(s) as display URL in paid media ads
          and to direct-link or redirect to the Service Provider Website(s); Use
          non-unique copyright infringing content to promote Service Provider;
          Use traffic generated by pay to read, pay to click, banner exchanges,
          click exchanges, PPV advertising, pop-up/under, or similar methods;
          Provide cash backs, rewards or any other kind of incentives to obtain
          the sale without our prior approval; Offer price savings methods,
          including coupon(s), voucher(s), discount codes, or added value offers
          without our prior approval; Use our advertising and promotional
          materials, trademark or name in a way that negatively affects our
          image; Use iframes or any other techniques or technology that places
          your affiliate tracking cookie in any means other than an actual
          click-through; Use link cloaking or masking techniques or technology
          with the goal to promote Service Provider on websites and/or networks
          not explicitly listed in your affiliate profile and hiding that
          traffic source; Use lewd, obscene, illegal or pornographic material,
          or any other material that is deemed to be objectionable on your
          website(s). This includes, but is not limited to, bigotry, hatred,
          pornography, satanic materials, trademark and copyright materials, all
          content of an adult nature, etc. The declaration of any materials as
          such is subject to our reasonable opinion; Use keywords and phrases
          containing the Service Provider trademark or any other variations or
          misspellings confusingly similar to Service Provider trademark, name,
          logo or domain name, without our prior approval, on your domain
          name(s), company name, logo, trademark, product(s), project(s),
          service(s); Use keywords and phrases that contain or are confusingly
          similar to third-party trademarks, names, logos or domain names unless
          you have been duly authorized by the trademark owner, on your domain
          name(s), company name, logo, trademark, your product(s), project(s),
          service(s). You may integrate paid advertisement on Your web resources
          in order to promote the Services and products of the Service Provider
          subject to the following conditions: Service Provider&rsquo;s written
          approval has been obtained by You at least 7 (seven) days prior
          integration of paid advertisement on Your web resources; Service
          Provider&rsquo;s written approval has been obtained by You towards key
          words to be used for paid advertisement which will lead users to Your
          web resources (there are restrictions on branded key words use, such
          as &laquo;simple swap&raquo; etc., which please note); You have
          provided Service Provider with access to Your Google Ads account with
          the at least right to observe the data.
        </p>

        <p
          style={{
            fontWeight: 400,
            fontSize: 30,
            paddingTop: 20,
            marginBottom: -30,
          }}
        >
          {" "}
          <img src={legal4} alt={"intellectual property"}></img> INTELLECTUAL
          PROPERTY
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Unless otherwise indicated by Us, Service Provider IP is the
          proprietary property of Service Provider or our licensors or suppliers
          and is protected by international copyright laws and other
          intellectual property rights laws. We hereby grant you a limited,
          nonexclusive and non-sub licensable license to access and use the
          Service Provider IP for your personal or business use solely for the
          purposes of regular use of the Services. The license granted will
          automatically terminate if We suspend or terminate your access to the
          Services.
        </p>

        <p
          style={{
            fontWeight: 400,
            fontSize: 30,
            paddingTop: 20,
            marginBottom: -30,
          }}
        >
          {" "}
          <img src={legal4} alt={"third party content"}></img> THIRD PARTY
          CONTENT
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Through the Services, You will have the ability to access and/or use
          content provided by third parties. The Service Provider cannot
          guarantee that such third party content will be free of material you
          may find objectionable or otherwise. The Service Provider disclaims
          any responsibility or liability related to your access or use of any
          third party content.
        </p>

        <p
          style={{
            fontWeight: 400,
            fontSize: 30,
            paddingTop: 20,
            marginBottom: -30,
          }}
        >
          {" "}
          <img src={legal4} alt={"limitation of liabilities"}></img>LIMITATION
          OF LIABILITIES
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Except as expressly provided to the contrary in a writing by Us, our
          services are provided on an &quot;As is&quot; and &quot;As
          available&quot; basis. WE EXPRESSLY DISCLAIM, AND YOU WAIVE, ALL
          WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, WITHOUT
          LIMITATION, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
          PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT AS TO OUR SERVICES,
          INCLUDING THE INFORMATION, CONTENT AND MATERIALS CONTAINED THEREIN.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Except as otherwise required by law, IN NO EVENT SHALL SERVICE
          PROVIDER, OUR DIRECTORS, OFFICERS, MEMBERS, EMPLOYEES OR AGENTS BE
          LIABLE FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL OR SPECIAL DAMAGES, OR
          ANY OTHER DAMAGES OF ANY KIND, INCLUDING, BUT NOT LIMITED TO, LOSS OF
          USE, LOSS OF PROFITS OR LOSS OF DATA, WHETHER IN AN ACTION IN
          CONTRACT, TORT (INCLUDING BUT NOT LIMITED TO NEGLIGENCE) OR OTHERWISE,
          ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OF OR INABILITY TO
          USE OUR SERVICES OR THE SERVICE PROVIDER IP, INCLUDING WITHOUT
          LIMITATION ANY DAMAGES CAUSED BY OR RESULTING FROM RELIANCE BY ANY
          USER ON ANY INFORMATION OBTAINED FROM SERVICE PROVIDER, OR THAT RESULT
          FROM MISTAKES, OMISSIONS, INTERRUPTIONS, DELETION OF FILES OR EMAIL,
          ERRORS, DEFECTS, VIRUSES, DELAYS IN OPERATION OR TRANSMISSION OR ANY
          FAILURE OF PERFORMANCE, WHETHER OR NOT RESULTING FROM A FORCE MAJEURE
          EVENT, COMMUNICATIONS FAILURE, THEFT, DESTRUCTION OR UNAUTHORIZED
          ACCESS TO SERVICE PROVIDER'S RECORDS, PROGRAMS OR SERVICES.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          To the maximum extent permitted by applicable law, IN NO EVENT SHALL
          THE AGGREGATE LIABILITY OF SERVICE PROVIDER (INCLUDING OUR DIRECTORS,
          OFFICERS, MEMBERS, EMPLOYEES AND AGENTS), WHETHER IN CONTRACT,
          WARRANTY, TORT (INCLUDING NEGLIGENCE, WHETHER ACTIVE, PASSIVE OR
          IMPUTED), PRODUCT LIABILITY, STRICT LIABILITY OR OTHER THEORY, ARISING
          OUT OF OR RELATING TO THE USE OF, OR INABILITY TO USE, OR TO THESE
          TERMS EXCEED THE FEES PAID BY YOU TO SERVICE PROVIDER WITHIN 3 MONTHS
          IMMEDIATELY PRECEDING THE DATE OF ANY CLAIM GIVING RISE TO SUCH
          LIABILITY.
        </p>

        <p
          style={{
            fontWeight: 400,
            fontSize: 30,
            paddingTop: 20,
            marginBottom: -30,
          }}
        >
          {" "}
          <img src={legal4} alt={"miscellaneous"}></img> MISCELLANEOUS
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Separability: If any provision of this Terms is deemed to be unlawful,
          invalid or unenforceable for any reason, such provision shall be
          deemed to be divisible and shall not affect the legal effect of any
          other provision.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Complaints: If you have any complaints, feedback, or questions, please
          contact our Customer Service at support@indexx.ai. When you contact
          us, please provide us with your name and email address and any other
          information we may need to identify you, and the transaction on which
          you have feedback, questions, or complaints.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          Miscellaneous: These Terms set forth the complete understanding of the
          parties with respect to the subject matter hereof and supersedes all
          prior understandings and communications relating thereto. No term or
          condition of any other document provided to Service Provider which is
          different from, inconsistent with, or in addition to the terms and
          conditions set forth herein will be binding upon the Parties. You
          represent and warrant that all information disclosed to Service
          Provider in connection with these Terms are true, accurate, and
          complete. Assignment. You may not assign or transfer any of your
          rights or obligations under these Terms without prior written consent
          from Service Provider, including by operation of law or in connection
          with any change of control. Service Provider may assign or transfer
          any or all of its rights under these Terms, in whole or in part,
          without obtaining your consent or approval.
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          No Waiver. Our failure or delay in exercising any right, power or
          privilege under these Terms shall not operate as a waiver thereof.
        </p>

        <p
          style={{
            fontWeight: 400,
            fontSize: 30,
            paddingTop: 20,
            marginBottom: -30,
          }}
        >
          {" "}
          <img src={legal4} alt={"applicable law and venue"}></img> APPLICABLE
          LAW AND VENUE
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          The Terms and your use of the Services will be governed by and
          construed in accordance with the laws of England and Wales. You agree
          that any action at law pursued by You and arising out of or relating
          to the Terms not subject to arbitration (as set forth below) will be
          filed only in the Court in the jurisdiction where Service Provider is
          respectively registered and You hereby irrevocably and unconditionally
          consent and submit to the exclusive jurisdiction of such court over
          any suit, action or proceeding arising out of the Terms.
        </p>

        <p
          style={{
            fontWeight: 400,
            fontSize: 30,
            paddingTop: 20,
            marginBottom: -30,
          }}
        >
          {" "}
          <img src={legal4} alt={"arbitration"}></img> ARBITRATION
        </p>

        <p style={{ lineHeight: 2 }}>
          <br />
          <br />
          You and Service Provider (&ldquo;All Parties&rdquo;) agree to
          arbitrate any dispute arising from these Terms or relating to the
          Service, except that you and Service Provider are not required to
          arbitrate any dispute in which either party seeks other relief for the
          alleged unlawful use of copyrights, trademarks, trade names, logos,
          trade secrets or patents. You and Service Provider agree that you will
          notify each other of any dispute within 30 days of when it arises,
          that you will attempt informal resolution prior to any demand for
          arbitration and that arbitration will be conducted confidentially by a
          single arbitrator. You and Service Provider also agree that the court
          in England and Wales, where Service Provider is located has exclusive
          jurisdiction over any appeals of an arbitration award and over any
          suit between the parties not subject to arbitration. In any
          arbitration, the parties will not seek discovery from each other, and
          the arbitrator shall not allow parties to engage in discovery; rather,
          each party shall disclose the evidence supporting their positions at
          some mutually agreeable time and date prior to the final hearing.
          Other than class procedures and remedies discussed below, the
          arbitrator has the authority to grant any remedy that would otherwise
          be available in court. Neither you nor Service Provider will
          participate in a class action or class-wide arbitration for any claims
          covered by these Terms. You also agree not to participate in claims
          brought in by a private attorney general or representative capacity,
          or consolidated claims involving another person, if any Party is a
          party to the proceeding. If the prohibition against class actions and
          other claims brought on behalf of third parties contained above is
          found to be unenforceable, then that language shall be deemed to have
          been dropped from these Terms and the remaining obligations relating
          to arbitration shall continue in full force and effect.
        </p>
      </div>
    </div>
  );
};

export default Termsofservice;
